module.exports = __webpack_public_path__ + "img/buyHomeBanner3.67d47de4.png";